// extracted by mini-css-extract-plugin
export var container = "_ds-1";
export var cornerButtonContainer = "_ds-6";
export var disabled = "_ds-2";
export var dragActive = "_ds-3";
export var fileContainer = "_ds-5";
export var hiddenInput = "_ds-4";
export var widthContainer = "_ds-0";